import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AppHeader } from "@/components/AppHeader";
import { SectionLabel } from "@/components/FormField";
import { RequestForm } from "@/components/portal/RequestForm";
import { RequestHistory } from "@/components/portal/RequestHistory";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export default function CustomerPortal() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    api.get("/requests/mine").then((r) => setJobs(r.data)).catch((e) => {
      toast.error(formatApiError(e));
      setJobs([]);
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#030712] cyber-grid" data-testid="customer-portal">
      <AppHeader />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 space-y-16">
        <section className="rise-in">
          <SectionLabel>new request</SectionLabel>
          <h1 className="font-display text-3xl sm:text-4xl uppercase tracking-wider mt-3 mb-2" data-testid="portal-greeting">
            Hey, {user?.name?.split(" ")[0]}
          </h1>
          <p className="text-slate-400 text-sm mb-8">Tell us the car and the route. You'll see the full price before you submit.</p>
          <RequestForm onCreated={(job) => setJobs((js) => [job, ...(js || [])])} />
        </section>
        <section className="rise-in" style={{ animationDelay: "100ms" }}>
          <SectionLabel>history</SectionLabel>
          <h2 className="font-display text-xl sm:text-2xl uppercase tracking-wider mt-3 mb-6">Your requests</h2>
          {jobs === null ? <p className="font-mono text-sm text-cyan-400 blink-caret">LOADING</p> : <RequestHistory jobs={jobs} />}
        </section>
      </main>
    </div>
  );
}
